// extracted by mini-css-extract-plugin
export var contentBody = "_dz-9";
export var headerImage = "_dz-2";
export var imageButton = "_dz-7";
export var imageButtonIcon = "_dz-8";
export var imageHeader = "_dz-4";
export var imageHeaderText = "_dz-5";
export var imageOverlay = "_dz-3";
export var imageTitle = "_dz-6";
export var imageWrapper = "_dz-1";
export var taskList = "_dz-a";
export var widget = "_dz-0";